export default {"src":"/_next/static/media/ship-play-text-only-dark.f296dbde.svg","height":20,"width":86,"blurWidth":0,"blurHeight":0};